import { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import { OverlayLoader } from "../../Components/Shimmers";
import slugify from "slugify";
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import { Helmet } from "react-helmet";
import { toast } from 'react-toastify';
import { AddToCartNotifier } from "../../Components/CartComponents";
import { CartsContext } from "../../Context/CartsContext";
import { axiosGet } from "../../Apis/axiosMethods";

const SpecialOffers = () => {
  const {
    apiURL,
    setIsCartDropdownOpen,
    business_type,
    currency
  } = useContext(ConfigContext);

  const {
    AddToCart,
    GetCartItemQty,
    loadings,
    GetStockPolicyItem
  } = useContext(CartsContext);

  const { gdcURL } = useContext(ConfigContext);
  const dir = localStorage.getItem("dir");
  const [loading, setLoading] = useState(true);
  const [parts, setParts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedBrandTags, setSelectedBrandTags] = useState([]);

  const [TotalParts, setTotalParts] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();

  const pageFromUrl = Number(searchParams.get("page")) || 1;
  const limitFromUrl = Number(searchParams.get("limit")) || 50;


  const [page, setPage] = useState(pageFromUrl);
  const [limit, setLimit] = useState(limitFromUrl);

  useEffect(() => {
    setSearchParams(prev => {
      const params = new URLSearchParams(prev);
      params.set("page", page);
      params.set("limit", limit);
      return params;
    });
  }, [page, limit]);

  const [TotalPages, setTotalPages] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [partName, setPartName] = useState("");
  const [selectedBrandsArray, setSelectedBrandsArray] = useState([]);
  const [expandedOeRows, setExpandedOeRows] = useState({});
  const [responsive] = useState({
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 10,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3,
      slidesToSlide: 1,
    },
  });
  const [car_info] = useState(
    localStorage.getItem("car_info")
      ? JSON.parse(localStorage.getItem("car_info"))
      : []
  );
  const navigate = useNavigate();

  useEffect(() => {
    LoadBrands();
  }, [])

  const toggleOeRow = (rowKey) => {
    setExpandedOeRows(prev => ({
      ...prev,
      [rowKey]: !prev[rowKey]
    }));
  };

  const LoadBrands = async () => {
    setLoading(true);
    try {
      const response = await axiosGet(`/Users/GetSpecialOffersBrands?part_number=${keyword}`);
      const uniqueBrands = [...new Map((response?.data?.data || []).map((item) => [item.sup_brand, item])).values()];

      setBrands(uniqueBrands);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const LoadParts = async () => {
    try {
      setLoading(true);

      const response = await axiosGet(
        `/Users/GetSpecialOffers`,
        {
          brands: selectedBrands,
          part_number: keyword,
          part_name: partName,
          limit: limit,
          page: page,
          currency,
          business_type
        }
      );

      const data = response?.data;

      if (data?.success) {

        setParts(data?.data);
        setTotalPages(data?.total_pages);
        setTotalParts(data?.total_records);
      }

    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    LoadParts();
  }, [selectedBrands, page, limit]);

  const handeSearch = () => {
    LoadParts();
  }

  const handleAddToCart = async (item, url) => {

    const prev_qty = Number(await GetCartItemQty(item.ART_SEARCH_NUMBER) || 0);

    const max_qty = Number(item.stock_available_qty);

    if (max_qty <= 0) {
      toast.error(
        <AddToCartNotifier
          item_name={"We dont have stock for this part"}
          item_img={""}
        />
      );
      return;
    }

    // Get Stock Policy
    const stockPolicy = await GetStockPolicyItem(
      item?.ART_SEARCH_NUMBER,
      item?.stock_oe,
      item?.ART_SUP_ID || item?.stock_sup_id,
      item?.ART_SUP_BRAND || item?.stock_brand_name
    );

    const minQty = Number(stockPolicy?.policy_min_qty || 1);

    // Default add qty
    let addQty = minQty;

    // Remaining stock
    const remainingStock = max_qty - prev_qty;

    // If remaining stock is less than min qty,
    // add remaining stock instead
    if (remainingStock < minQty && remainingStock > 0) {
      addQty = remainingStock;
    }

    if (remainingStock <= 0) {
      toast.error(
        <AddToCartNotifier
          item_name={`Sorry, only ${max_qty} items available`}
          item_img={""}
        />
      );
      return;
    }

    const partImg = item.MEDIA_SOURCE
      ? item.MEDIA_SOURCE
      : `${apiURL}/public/placeholder_category.jpeg`;

    await AddToCart(item, addQty, partImg, url);

    setIsCartDropdownOpen(true);
    window.scrollTo(0, 0);
  };



  const toggleBrand = (SUP_ID, SUP_BRAND, ART_TYPE) => {
    setSelectedBrands((prevSelectedBrands) => {
      if (prevSelectedBrands.includes(SUP_ID)) {
        return prevSelectedBrands.filter((id) => id !== SUP_ID);
      } else {
        return [...prevSelectedBrands, SUP_ID];
      }
    });

    setSelectedBrandsArray((prevArray) => {

      const index = prevArray.findIndex((item) => item.SUP_ID === SUP_ID);
      if (index === -1) {
        const newArray = [...prevArray, { SUP_ID, SUP_BRAND, ART_TYPE }];
        return newArray;
      } else {
        const newArray = prevArray.filter((item) => item.SUP_ID !== SUP_ID);
        return newArray;
      }
    });

    let setSelectedBTs = [...selectedBrandTags];
    const index = selectedBrandTags.findIndex((tag) => tag.SUP_ID === SUP_ID);
    if (index === -1) {
      setSelectedBTs.push({ SUP_ID, SUP_BRAND, ART_TYPE });
    } else {
      setSelectedBTs.splice(index, 1);
    }

    setSelectedBrandTags(setSelectedBTs);
    setPage(1);
  };

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const { carouselState: { currentSlide } } = rest;
    return (
      <div className="carousel-button-group">
        <button style={{ padding: '2px 6px', position: 'absolute', left: 0, top: '8px', marginLeft: '-40px' }} className={currentSlide === 0 ? 'btn btn-outline-dark btn-sm disable' : 'btn btn-outline-dark btn-sm '} onClick={() => previous()} > <i className="fas fa-chevron-left"></i> </button>
        <button style={{ padding: '2px 6px', position: 'absolute', right: 0, top: '8px', marginRight: '-30px' }} className="btn btn-outline-dark btn-sm" onClick={() => next()} ><i className="fas fa-chevron-right"></i></button>
      </div>
    );
  };

  const BrandsOptions = () => {
    const divs = <div style={{ position: 'relative' }} className={`prevent-select `}>

      <Carousel
        arrows={false}
        renderButtonGroupOutside={brands.length > 10}
        customButtonGroup={<ButtonGroup />}
        responsive={responsive}
        swipeable={true}
        draggable={true}
        showDots={false}
        infinite={false}
        autoPlaySpeed={1000}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={500}
        containerClass="carousel-container"
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px">
        {brands &&
          [...brands]
            .sort((a, b) => selectedBrands.includes(b.SUP_ID) - selectedBrands.includes(a.SUP_ID))
            .map((img, index) => {
              return (
                <div
                  key={`img-sup-brand-${index}`}
                  onClick={() => {
                    toggleBrand(
                      img.SUP_ID,
                      img.stock_brand_name.trim().replace(/[\r\n]/g, '').replace(/&/g, '__AMP__'),
                      'IAM'
                    );
                    window.scrollTo(0, 0);
                  }}
                  style={{
                    cursor: 'pointer',
                    height: '40px',
                    width: '80px',
                    textAlign: 'center',
                    border: selectedBrands.includes(img.SUP_ID)
                      ? '2px solid #cc000b'
                      : '0px solid #CCC',
                  }}
                >
                  <ImageWithFallback
                    src={`${gdcURL}/sup-logo/${img.SUP_LOGO_NAME}`}
                    alt={img.ART_SUP_BRAND}
                    index={index}
                    fallbackText={img.ART_SUP_BRAND}
                    OE={false}
                  />
                </div>
              );
            })}

      </Carousel>
    </div>
    return divs;
  }

  const getPageNumbers = () => {
    const pages = [];
    const total = TotalPages;
    const windowSize = 5;

    let start = page;
    let end = page + windowSize - 1;

    // If end exceeds total pages
    if (end > total) {
      end = total;
      start = total - windowSize + 1;
    }

    // If start goes below 1
    if (start < 1) {
      start = 1;
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);

    setLimit(newLimit);
    setPage(1);
    setSearchParams({ page: 1 });
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > TotalPages) return;

    setSearchParams({ page: pageNumber });
    setPage(pageNumber)

    const tableTop = document.getElementById("parts-table-top");
    if (tableTop) {
      tableTop.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };

  return (
    <>
      {
        loading ?
          <div style={{ height: "70vh" }}>
            <OverlayLoader />
          </div>
          :
          <div
            className="header-bottom  d-none d-lg-block"
            style={{
              borderBottom: "1px solid rgb(226, 226, 226)",
              marginBottom: "10px",
            }}>
            <Helmet>
              <title>Special Offer (MOQ)</title>
            </Helmet>
            <div className="container">

              <nav
                className="main-nav w-100"
                style={{ textAlign: dir === "rtl" ? "right" : "left" }}>
                <div className="row justify-content-center">
                  <div className="col-md-11">
                    <div className="row justify-content-end">
                      <div className="col-md-7"><h4 className="mt-3">Special Offer (MOQ)</h4></div>
                      <div className="col-md-5">
                        <div className="d-flex align-items-center mt-2">
                          <input
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                handeSearch();
                              }
                            }}
                            type="text"
                            onChange={(e) => setKeyword(e.target.value)}
                            className="form-control me-2"
                            placeholder="Enter part number"
                            value={keyword}
                            style={{ borderRadius: 0, marginRight: '6px' }}
                          />
                          {/* OR text between fields */}
                          <span style={{ marginBottom: '10px', marginRight: '8px', fontWeight: 600, color: '#000', fontSize: 16 }}>OR</span>
                          <input
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                handeSearch();
                              }
                            }}
                            type="text"
                            onChange={(e) => setPartName(e.target.value)}
                            className="form-control me-2"
                            placeholder="Enter part name"
                            value={partName}
                            style={{ borderRadius: 0, marginRight: '6px', minWidth: 120 }}
                          />
                          <button
                            onClick={() => handeSearch()}
                            type="button"
                            className="btn btn-primary"
                            style={{ marginTop: '-10px', padding: '12px' }}
                          >
                            Search
                          </button>

                        </div>
                      </div>
                    </div>

                    <BrandsOptions />

                    <table className="table table-striped table-bordered enable-select">
                      <thead>
                        <tr>
                          <th>SR No.</th>
                          <th style={{ verticalAlign: 'middle' }} width="400">Part Name</th>
                          <th style={{ minWidth: '150px', verticalAlign: 'middle' }}>Part Number</th>

                          <th style={{ verticalAlign: 'middle' }}>Brand</th>

                          <th>Available QTY</th>
                          <th style={{ width: '190px', verticalAlign: 'middle' }}>
                            Offer unite price {/* <small>incl. 5.0% VAT</small> */}
                          </th>

                          <th>MOQ</th>
                          <th>OE Number</th>
                          <th>Info</th>
                          <th>Buy</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          parts && parts.length > 0 && parts.map((part, series) => {

                            if (part === null) {
                              return <tr key={series}></tr>
                            }

                            const beforePrice = business_type === 1
                              ? part?.stock_before_bg_price
                              : part?.stock_before_bb_price;

                            const display_price = business_type === 1
                              ?
                              Number(part.stock_bg_price).toFixed(2)
                              :
                              Number(part.stock_bb_price).toFixed(2)

                            const productSlug = slugify(
                              (part?.PRODUCT_GROUP_EN || "-")
                                .replace(/,/g, "")
                                .toLowerCase()
                            );
                            const url = `/Spare-Parts/Details/${productSlug}-${part?.ART_SEARCH_NUMBER}-${part?.ART_SUP_ID}`;

                            let oeNumbers = [];

                            if (part.OE_NUMBERS_CROSS) {
                              try {
                                oeNumbers = typeof part.OE_NUMBERS_CROSS === "string"
                                  ? JSON.parse(part.OE_NUMBERS_CROSS || "[]")
                                  : part.OE_NUMBERS_CROSS || [];
                              } catch {
                                oeNumbers = [];
                              }
                            }

                            return <tr key={part.ART_ID + '-' + series}>
                              <td style={{ verticalAlign: 'middle' }} width={10}>
                                {(page - 1) * limit + series + 1}
                              </td>
                              <td style={{ verticalAlign: 'middle' }} width="20%"><NavLink to={url}>{part && part.PRODUCT_GROUP_EN}</NavLink></td>
                              <td style={{ verticalAlign: 'middle' }} width="10%">{part.ART_ARTICLE_NR}</td>
                              <td style={{ verticalAlign: 'middle' }} width="10%">{part.ART_SUP_BRAND}</td>
                              <td style={{ verticalAlign: 'middle' }}>{part.stock_available_qty}</td>

                              <td style={{ verticalAlign: 'middle' }}>
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    gap: "6px",
                                    flexWrap: "nowrap",
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  <span style={{ fontWeight: 600, fontSize: "14px" }}>
                                    {part?.display_price}
                                  </span>

                                  {beforePrice > 0 && beforePrice > display_price && (
                                    <small
                                      className="text-muted"
                                      style={{
                                        whiteSpace: "nowrap"
                                      }}
                                    >
                                      Was:{" "}
                                      <del>
                                        {beforePrice.toFixed(2)}{currency?.toUpperCase()}
                                      </del>
                                    </small>
                                  )}
                                </div>

                              </td>



                              <td style={{ verticalAlign: 'middle' }}>{part.stock_special_offer_min_qty}</td>

                              <td style={{ verticalAlign: 'middle' }}>
                                {(() => {
                                  const oeNumbers = typeof part.OE_NUMBERS_CROSS === "string"
                                    ? JSON.parse(part.OE_NUMBERS_CROSS || "[]")
                                    : part.OE_NUMBERS_CROSS || [];

                                  const seen = new Set();
                                  const uniqueOEs = [];

                                  for (const oe of oeNumbers) {
                                    if (oe.ARL_DISPLAY_NR && !seen.has(oe.ARL_DISPLAY_NR)) {
                                      uniqueOEs.push(oe.ARL_DISPLAY_NR);
                                      seen.add(oe.ARL_DISPLAY_NR);
                                    }
                                  }
                                  if (uniqueOEs.length === 0) return <span>-</span>;
                                  const isExpanded = expandedOeRows[part.ART_ID];
                                  if (uniqueOEs.length <= 2 || isExpanded) {
                                    return (
                                      <>
                                        {uniqueOEs.map((oe, idx) => (
                                          <span key={oe}>
                                            <NavLink
                                              onClick={() => {
                                                window.scrollTo({
                                                  top: 0,
                                                  behavior: "smooth",
                                                });
                                              }}
                                              to={`/Spare-Parts/OEM/${part.ART_ID}/${oe?.replace(/[^a-zA-Z0-9]/g, '')}/${part.PRODUCT_GROUP_EN?.replace(/[^a-zA-Z0-9\s]/g, '-')}-${oe?.replace(/[^a-zA-Z0-9]/g, '')}`}>
                                              {oe}
                                            </NavLink>
                                            {idx < uniqueOEs.length - 1 ? ', ' : ''}
                                          </span>
                                        ))}
                                        {uniqueOEs.length > 2 && (
                                          <span
                                            style={{
                                              color: "#007bff",
                                              cursor: "pointer",
                                              marginLeft: 4,
                                              fontWeight: 500,
                                              position: "relative"
                                            }}
                                            onClick={() => toggleOeRow(part.ART_ID)}
                                          >
                                            &nbsp;- less
                                          </span>
                                        )}
                                      </>
                                    );
                                  }
                                  return (
                                    <>
                                      {uniqueOEs.slice(0, 2).map((oe, idx) => (
                                        <span key={oe}>
                                          <NavLink
                                            to={`/Spare-Parts/OEM/${part.ART_ID}/${oe?.replace(/[^a-zA-Z0-9]/g, '')}/${part.PRODUCT_GROUP_EN?.replace(/[^a-zA-Z0-9\s]/g, '-')}-${oe?.replace(/[^a-zA-Z0-9]/g, '')}`}
                                          >
                                            {oe}
                                          </NavLink>
                                          {idx < 1 ? ', ' : ''}
                                        </span>
                                      ))}

                                      <span
                                        style={{
                                          color: "#007bff",
                                          cursor: "pointer",
                                          marginLeft: 4,
                                          fontWeight: 500,
                                          position: "relative"
                                        }}
                                        onClick={() => toggleOeRow(part.ART_ID)}
                                      >
                                        +more
                                      </span>
                                    </>
                                  );
                                })()}
                              </td>


                              <td style={{ verticalAlign: 'middle' }}>
                                <button onClick={() => navigate(url)} className="btn btn-sm btn-info">
                                  <i className="fas fa-info-circle"></i> Details
                                </button>
                              </td>

                              <td style={{ verticalAlign: 'middle' }}>
                                <button
                                  className="btn btn-sm btn-dark"
                                  type="button"
                                  onClick={() => handleAddToCart(part, url)}
                                  disabled={loadings}
                                >
                                  <i className="fas fa-cart-plus"></i> Buy
                                </button>
                              </td>
                            </tr>
                          })
                        }
                      </tbody>

                      {TotalPages > 1 && (
                        <tfoot>
                          <tr>
                            <td colSpan={10}>

                              <div className="d-flex justify-content-end align-items-center flex-wrap gap-2">

                                {/* Show entries info */}
                                <div className="show-entries">
                                  Showing {(page - 1) * limit + 1} to {Math.min(page * limit, TotalParts)} of {TotalParts} entries
                                </div>

                                {/* Right side controls */}
                                <div className="d-flex align-items-center gap-3">

                                  {/* Pagination */}
                                  <nav>
                                    <ul className="custom-pagination mb-0">
                                      <li
                                        className={`page-btn ${page === 1 ? "disabled" : ""}`}
                                        onClick={() => page > 1 && handlePageChange(1)}
                                      >
                                        &laquo;
                                      </li>

                                      {/* Previous */}
                                      <li
                                        className={`page-btn ${page === 1 ? "disabled" : ""}`}
                                        onClick={() => page > 1 && handlePageChange(page - 1)}
                                      >
                                        &lt;
                                      </li>

                                      {/* Pages */}
                                      {getPageNumbers().map((p, index) => (
                                        p === "..." ? (
                                          <li key={`dots-${index}`} className="page-btn dots">...</li>
                                        ) : (
                                          <li
                                            key={p}
                                            className={`page-btn ${p === page ? "active" : ""}`}
                                            onClick={() => handlePageChange(p)}
                                          >
                                            {p}
                                          </li>
                                        )
                                      ))}

                                      {/* Next */}
                                      <li
                                        className={`page-btn ${page === TotalPages ? "disabled" : ""}`}
                                        onClick={() => page < TotalPages && handlePageChange(page + 1)}
                                      >
                                        &gt;
                                      </li>

                                      <li
                                        className={`page-btn ${page === TotalPages ? "disabled" : ""}`}
                                        onClick={() => page < TotalPages && handlePageChange(TotalPages)}
                                      >
                                        &raquo;
                                      </li>

                                    </ul>
                                  </nav>

                                  <div className="d-flex align-items-center" style={{ marginLeft: "10px" }}>
                                    <select
                                      className="form-control form-control-sm"
                                      value={limit}
                                      onChange={handleLimitChange}
                                    >
                                      <option value={50}>50</option>
                                      <option value={100}>100</option>
                                      <option value={150}>150</option>
                                      <option value={200}>200</option>
                                      <option value={250}>250</option>
                                    </select>
                                  </div>

                                </div>
                              </div>


                            </td>
                          </tr>
                        </tfoot>
                      )}

                    </table>
                  </div>
                </div>

              </nav>
            </div>
            {/* End .container */}
          </div>
      }
    </>
  )
};

const ImageWithFallback = ({ src, index, alt, fallbackText, OE }) => {
  const [imgError, setImgError] = useState(false);

  const handleError = () => {
    setImgError(true);
  };


  const fallbackStyle = {
    textAlign: "center",
    fontSize: "10px",
    padding: "10px",
    wordBreak: "break-word",
    maxWidth: "90%",
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <div style={containerStyle}>
      {imgError ? (
        <div style={fallbackStyle}>{fallbackText}</div>
      ) : (
        <img
          draggable="false"
          style={{
            height: "30px",
            margin: "auto",
            float: "none",
            marginTop: OE === false ? "5px" : 0,
          }}
          key={`img-part-${index}`}
          src={src}
          alt={alt}
          onError={handleError}
        />
      )}
    </div>
  );
};

export default SpecialOffers;


